"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.disableEmotionWarnings = void 0;
function disableEmotionWarnings() {
    if (process.env.NODE_ENV !== "development") {
        return;
    }
    /* eslint-disable no-console */
    var log = console.error.bind(console);
    console.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        /* eslint-enable no-console */
        if (args.indexOf("The pseudo class") &&
            args.indexOf("is potentially unsafe when doing server-side rendering. Try changing it to")) {
            return;
        }
        log.apply(void 0, __spreadArray([], __read(args), false));
    };
}
exports.disableEmotionWarnings = disableEmotionWarnings;
//# sourceMappingURL=disableEmotionWarnings.js.map